import { Component, OnInit, HostBinding } from '@angular/core';
import { slideToRight } from '../../../shared/animations.collections';
import { EventListenerService } from '../../../services/close-listenenr.service';
import { NavMenu } from '../nav-menu';
import { CommonService } from '../../../services/common.service';
import { FeedbackInfo} from '../../../models/feedback-info.model';
import { ApiResponse } from '../../../models/api-response.model';
import { Subscription } from 'rxjs';
import { AuthService } from '../../../services/auth.service';
import { ExternalScriptService } from '../../../services/external-script.service';
import { DDAIService } from '../../../services/dd-ai.service';

@Component({
    selector: 'app-chat-bot',
    templateUrl: './chat-bot.component.html',
    styleUrls: ['./chat-bot.component.css'],
    animations: [slideToRight()]
})
export class ChatBotComponent extends NavMenu implements OnInit {

    @HostBinding('@slideToRight') ani;

    title = "HELP";
    sendComments:FeedbackInfo = <FeedbackInfo>{};
    disableButton: boolean;
    errorMsg: string;
    showResult: boolean;
    imageFile: any;
    formData = new FormData();
    fileList: FileList;
    hasEmptyQuestions:boolean = true;
    response:ApiResponse;
    passQuestionSubscription$: Subscription;
    completeSubmission:boolean = false;
    fileListArr = [];
    loading = true;

    constructor(
        closeListener: EventListenerService,        
        private commonService:CommonService,
        private ddaiService: DDAIService
    ) {
        super(closeListener);
    }

    ngOnInit():void {
        // Initial update
        this.ddaiService.updateElementHeight();

        // Update on window resize
        $(window).on('resize', this.ddaiService.updateElementHeight);

        this.loading = true;
        // this.externalScriptService
        //   .loadScript(`https://ddai.dickerdata.online/embed.js?token=${DDAICookie}`)
        //   .then(() => {
        //     this.externalScriptService.runMyScript();
            this.ddaiService.initDDAIBotScript().subscribe((response: any) => {
                this.loading = false;
                const ddaidev = document.getElementById('ddai');

                var localstyles = document.createElement('link');
                localstyles.rel = 'stylesheet';
                localstyles.href = `https://ddai.dickerdata.online/styles.css`;
                ddaidev.appendChild(localstyles);

                var scriptNode = document.createElement('script');
                scriptNode.innerHTML = response.script;
                ddaidev.appendChild(scriptNode);

                var htmlnode = document.createElement('div');
                htmlnode.innerHTML = response.html;
                ddaidev.appendChild(htmlnode);
              },
              (error: any) => {
                console.error(error);
              });
        //   })
        //   .catch((error) => console.error(error));

    

    }

    //Called when a end-user upload a image
    onSelectFile(event) : void {
        this.fileList = event.target.files;
        // Multiple Image uploading
        // for (var i = 0; i < this.fileList.length; i++) {
        //     console.log(this.fileList[i]);
        //     this.fileListArr.push(this.fileList[i]);
        // }

        // if(this.fileListArr.length === this.fileList.length){
        //     for (var i = 0; i < this.fileListArr.length; i++) {
        //         this.formData.append(this.fileListArr[i].name, this.fileListArr[i]);
        //     }
        // }

        // Single Image uploading
        if(this.fileList.length > 0){
            console.log("user uplaod a image");
            this.imageFile = event.target.files[0];
            this.formData.append(this.imageFile.name, this.imageFile);
            for (var i = 0; i <= this.fileList.length - 1; i++) {
                this.fileListArr.push(this.fileList[i]);
            }
          
        }
    }
    onSubmit(): void {

    }

    // ngOnDestroy(): void {
    //     console.log('destroy');
    //     if(this.passQuestionSubscription$){
    //         this.passQuestionSubscription$.unsubscribe();
    //     }
    // }
}
